// --- Core ---
import {map, reject} from 'underscore';
// --- SaniQ ---
import {Patient} from "../../../models/Patient";
import * as PatientsConstants from '../constants';

interface PatientsState {
  collection: Patient[];
  query: string;
}

const initialState: PatientsState = {
  collection: [],
  query: undefined
};

export function patients(state: PatientsState = initialState, action): PatientsState {
  switch (action.type) {
    case PatientsConstants.SET_PATIENTS_QUERY:
      return Object.assign({}, state, {query: action.query});
    case PatientsConstants.DELETE_COMPLETED: {
      const newCollection = reject(state.collection, (patient) => patient.id === action.patient.id);

      return {...state, collection: newCollection};
    }

    case PatientsConstants.INACTIVE_PATIENT_COMPLETED: {
      const newCollection = map(state.collection,
        (patient) => {
          if (patient.id.toString() === action.patient.id.toString()) {
            return {
              ...patient,
              inactive: action.patient.inactive
            };
          }

          return patient;
        });

      return {...state, collection: newCollection};
    }
    default:
      return state;
  }
}
